export const selectInvoiceState = (state) =>
  state.shoppingCard.productsInInvoice;
